import _ from 'lodash';
import environment from '../../../environment';
import { NOTIFY_TYPE, notifyError, notifySuccess } from '../../../shared';
import fetch from '../../fetch';
import reducers from './reducers';

require('moment-duration-format');

const upload = (() => {
    const verify = () => {
        return fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/message/obterporusuario/`
        }).then(res => res, notifyError);
    };

    const validate = (id, date) => {
        return fetch({
            type: 'POST',
            url: `${environment.get('API_HOST')}/import/validatefiles/`,
            data: JSON.stringify({
                reportId: id,
                referenceDate: date
            })
        }).then(res => res, notifyError);
    };

    const execute = (id, date) => {
        return fetch({
            type: 'POST',
            url: `${environment.get('API_HOST')}/import/execute/`,
            data: JSON.stringify({
                reportId: id,
                referenceDate: date
            })
        }).then(res => res, notifyError);
    };

    const update = {
        models: {
            series (data) {
                return fetch({
                    type: 'POST',
                    data: JSON.stringify(data),
                    url: `${environment.get('API_HOST')}/relatorioconfiguracao/VincularModelosSerie/`
                });
            }
        },

        family (data) {
            return fetch({
                type: 'POST',
                data: JSON.stringify(data),
                url: `${environment.get('API_HOST')}/relatorioconfiguracao/AtualizarFamilia/`
            });
        },

        status: {
            reset (id, date) {
                return fetch({
                    type: 'POST',
                    data: JSON.stringify({
                        reportId: id,
                        referenceDate: date
                    }),
                    url: `${environment.get('API_HOST')}/import/reset/`
                });
            }
        }
    };

    const get = {
        history (id, date) {
            return fetch({
                type: 'GET',
                url: `${environment.get('API_HOST')}/import/GetReportFiles/`,
                data: {
                    reportId: id,
                    referenceDate: date
                }
            }).then((res) => reducers.history(res, { id, date }), notifyError);
        },

        family () {
            return fetch({
                type: 'GET',
                url: `${environment.get('API_HOST')}/relatorioconfiguracao/ObterFamilias/`
            }).then(reducers.family, notifyError);
        },

        errors (id, date) {
            return fetch({
                type: 'GET',
                url: `${environment.get('API_HOST')}/import/geterrors/`,
                data: {
                    reportId: id,
                    referenceDate: date
                }
            }).then(reducers.errors, notifyError);
        },

        models (id, name) {
            return fetch({
                type: 'GET',
                data: {
                    idFamilia: id
                },
                url: `${environment.get('API_HOST')}/relatorioconfiguracao/ObterModelosFamilia/`
            }).then((res) => reducers.models(res, { id, name }), notifyError);
        },

        series (id, name) {
            return fetch({
                type: 'GET',
                data: {
                    idFamilia: id
                },
                url: `${environment.get('API_HOST')}/relatorioconfiguracao/ObterSeries/`
            }).then((res) => reducers.series(res, { id, name }), notifyError);
        }
    };

    get.models.unassigned = () => {
        const _success = res =>
            _.map((res), r =>
                ({
                    id: r.Id,
                    name: r.Nome,
                    alias: r.NomeSufixo,
                    series: r.IdSerie
                })
            );

        return fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/relatorioconfiguracao/ObterModelosDesvinculados/`
        }).then(_success, notifyError);
    };

    const SendReportEmail = (id, date, sendTo) => {
        const _success = () => {
            const message = { type: NOTIFY_TYPE.SUCCESS, text: 'Email enviado com sucesso!' };
            notifySuccess(message);
        };

        return fetch({
            type: 'POST',
            data: JSON.stringify({
                reportId: id,
                referenceDate: date,
                sendTo
            }),
            url: `${environment.get('API_HOST')}/import/SendReportEmail/`
        }).then(_success, notifyError);
    };

    return {
        execute,
        get,
        update,
        validate,
        verify,
        SendReportEmail
    };
})();

export default upload;



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/upload/index.js